/* globals window */

export const showIntercom = () => {
  if (window && window.Intercom) {
    window.Intercom('show')
  }
}

export const hideIntercom = () => {
  if (window && window.Intercom) {
    window.Intercom('hide')
  }
}
